module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_4.4bbe8906.pdf";